<script>
    const music = MusicKit.getInstance();
</script>

<div class="message">
    <div>
        You need to log-in first.<br /><br />
        Not subscribed to Apple Music ?
    </div>
    <div class="subscription-message">
        =&gt; 🎵 <a href={music.subscribeURL}>Normal subscription</a><br />
        =&gt; 🏠
        <a href={music.subscribeFamilyURL}>Family subscription</a><br />
        =&gt; 👨🏽‍🎓
        <a href={music.subscribeStudentURL}>Student subscription</a><br />
    </div>
</div>

<style>
    .message {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;
    }

    .subscription-message {
        text-align: left;
    }

    .subscription-message > a {
        color: #277fff;
    }
</style>